import type { ChangeEvent } from "react";
import { useCallback, useEffect, useState } from "react";
import { debounce } from "throttle-debounce";
import { useAppDispatch } from "../../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../../services/redux/hooks/use-selector";
import { selectSelectedStore } from "../redux/selectors";
import { TEntityInfo } from "../../../common/types/utility";
import {
  deleteStoreAction,
  updateStoreAction,
} from "../redux/actions/openai_store_actions";
import {
  deleteLocalStoreAction,
  updateLocalStoreAction,
} from "../redux/actions/local_store_actions";

export const useDatabase = () => {
  const dispatch = useAppDispatch();
  const selectedStore = useAppSelector(selectSelectedStore);
  const [storeName, setStoreName] = useState<string>(selectedStore?.name ?? "");

  useEffect(() => {
    setStoreName(selectedStore?.name ?? "");
  }, [selectedStore]);

  const updateStore = useCallback(
    debounce(1000, (storeName: string) => {
      if (selectedStore?.metadata.type === "local") {
        dispatch(updateLocalStoreAction(storeName));
      } else {
        dispatch(updateStoreAction(storeName));
      }
    }),
    [selectedStore]
  );

  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    const name = event.target.value;
    setStoreName(name);
    updateStore(name);
  };

  const deleteStore = useCallback(
    (info: TEntityInfo | null) => {
      if (info) {
        if (selectedStore?.metadata.type === "local") {
          dispatch(deleteLocalStoreAction(info.id));
        } else {
          dispatch(deleteStoreAction(info.id));
        }
      }
    },
    [selectedStore]
  );

  return {
    storeName,
    selectedStore,
    handleNameChange,
    deleteStore,
  };
};
